<div class="main">
    <app-public-header  [company]="company" [branch]="branch"></app-public-header>

    <div class=" innerbody">
        <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
                styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
        </div>
        <div>
            <h1 class="registrationHeading">Registration</h1>
        </div>
        <form #form="ngForm" (ngSubmit)="submit(form)">

            <div *ngIf="activeIndex == 0">

                <!-- <div class="registrationErrorMsg" [ngClass]="{success: isSuccess, error: isError}">{{message}}</div> -->
                <div class=" card , registrationDiv">
                    <div class="apiResponceMessage" *ngIf="isMessage">
                        <div style="position: relative;">
                            <p-message class="errors" *ngIf="isMessage && isError" severity="error"
                                text="{{message}}"></p-message>
                            <p-message class="successs" *ngIf="isMessage && isSuccess" severity="success"
                                text="{{message}}"></p-message>
                            <span
                                style="position: absolute; top: 0px; right: 9px; cursor: pointer; font-size: 17px; color: #ddd;"
                                (click)="errorMsgClose()">
                                <i class="fa fa-times"></i>
                            </span>
                        </div>
                    </div>
                    <div>
                        <div class=" app-member-self-signup-field">
                            <span class=""><i class="icon" class="fa fa-user" aria-hidden="true"></i></span>
                            <input required autocomplete="off" pattern="[A-Za-z ]+"
                                [ngClass]="name.invalid && (name.dirty || name.touched) ? 'errorInput' : '' "
                                type="text" placeholder="Name * (as per CNIC)" minlength="3" maxlength="100" ngModel
                                name="name" #name="ngModel" id="name">
                                <div *ngIf="name.invalid && name.touched" class="errorFixNew">
                                    <div *ngIf="name.errors.required" class="errorShow">
                                        Please enter your name.
                                    </div>
                                    <div *ngIf="name.errors.pattern " class="errorShow">
                                        Your name must contain only letters.
                                    </div>
                                    <div *ngIf="!name.errors.pattern && name.errors.minlength" class="errorShow">
                                        Name should be minimum 3 characters.
                                    </div>
                                </div>
                        </div>
                    </div>
                    <!-- /////////////////////////////mobile////////// -->
                    <div>
                        <div class=" app-member-self-signup-field">
                            <app-phone-input
                                id="mobile"
                                name="mobile"
                                placeholder="Mobile *"
                                [(ngModel)]="mobile"
                                [required]="true">
                            </app-phone-input>
                        </div>
                    </div>
                    <!-- //////////////////////email/////////////////////////// -->
                    <div>
                        <div class="app-member-self-signup-field" style="display: flex;">
                            <span><i class="icon" class="fa fa-envelope" aria-hidden="true"></i></span>
                            <input required maxlength="256"
                                [ngClass]="email.invalid && (email.dirty || email.touched) ? 'errorInput' : '' "
                                autocomplete="off" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                                (input)="checkEmailExistEvent($event)" [(ngModel)]="emailAddress" name="email"
                                #email="ngModel" id="email" type="email" placeholder="Email * ">
                            <div class="p-g-0 loadingFixNew">
                                <ng-template [ngIf]="isEmailLoader">
                                    <div class="ui-g-12">
                                        <div class="spinit">
                                            <i class="fa fa-spinner" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                            <div class="errorFixNew">
                                <ng-template [ngIf]="email.invalid && (email.dirty || email.touched)">
                                    <div>
                                        <div *ngIf="email.errors.required" class="errorShow">
                                            Please enter your email address.
                                        </div>
                                        <div *ngIf="email.errors.pattern" class="errorShow">
                                            Please enter a valid email. e.g. (john@example.com)
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template [ngIf]="isEmailExist && !email.errors.pattern">
                                    <div class="errorShow">
                                        The email address you entered is already taken.
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <!-- ////////////////////NIC///////////////////////// -->
                    <div>
                        <div class="app-member-self-signup-field">
                            <span><i class="icon" class="fa-sharp fa fa-id-card" aria-hidden="true"></i></span>
                            <input autocomplete="off" pattern="[0-9]+"
                                [ngClass]="CNIC.invalid && (CNIC.dirty || CNIC.pattern || CNIC.errors.minlength) ? 'errorInput' : '' "
                                ngModel name="CNIC" minlength="13" maxlength="13" #CNIC="ngModel" id="CNIC" type="text"
                                placeholder="CNIC">
                                <div *ngIf="CNIC.invalid && (CNIC.dirty || CNIC.pattern || CNIC.errors.minlength ) " class="errorFixNew">
                                    <div *ngIf="CNIC.errors.pattern" class="errorShow">
                                        Please enter your CNIC number e.g. 1234567890123
                                    </div>
                                    <div *ngIf="!CNIC.errors.pattern && CNIC.errors.minlength" class="errorShow">
                                        CNIC should be 13 digits e.g. 1234567890123
                                    </div>
                                </div>
                        </div>
                    </div>
                    <!-- ////////////////////////Address////////////////////// -->
                    <div>
                        <div class="app-member-self-signup-field locationFix">
                            <span><i class="icon" class="fa fa-map-marker" aria-hidden="true"></i></span>
                            <input autocomplete="off" ngModel name="street" #street="ngModel" maxlength="256"
                                id="street" type="text" placeholder=" Street / Sector">&nbsp;
                            <div>
                                <select class="dropdown" [ngModel]="selectedCity" name="city" id="city">
                                    <option *ngFor="let city of cities"> {{city}} </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="genderDiv">
                        <div>
                            <p-radioButton name="gender" value="M" label="Male" [(ngModel)]="gender" inputId="opt1">
                            </p-radioButton>
                        </div>
                        <div class="">
                            <p-radioButton name="gender" value="F" label="Female" [(ngModel)]="gender" inputId="opt2">
                            </p-radioButton>
                        </div>
                    </div>
                    <div class="procced ">
                        <input type="submit" id="proceed"
                        class="p-button submitButton p-widget p-state-default p-corner-all" value="Proceed" />
                    </div>
                </div>
                <!-- /////////////submit//////////////// -->
            </div>
        </form>
        <!-- //////////////////////////////////OTP////////////////////////// -->
        <div class="responsive" *ngIf="activeIndex == 1">
            <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
                    styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE"
                    animationDuration=".5s"></p-progressSpinner></div>
            <div class="OTPDiv">
                <div >
                    <p-message class="errors" *ngIf="isError" severity="error" text="{{otpErrorMessage}}"></p-message>
                </div>
                <h4>{{OTPHeading}}</h4>
            </div>
            <div class="mainOTP">
                <div style="margin-top: 8px !important;" class="app-member-self-signup-field">
                    <input required
                        [ngClass]="OTP.invalid && (OTP.dirty || OTP.touched || OTP.maxlength) ? 'errorInput' : '' "
                        ngModel class="otp-input" autocomplete="off" id="OTP" #OTP="ngModel" name="OTP"
                        placeholder="Please enter the OTP that was sent to your mobile number. *" pattern="[0-9]+"
                        type="text" minlength="4" maxlength="4">
                </div>
                <div *ngIf="OTP.invalid && (OTP.touched || OTP.dirty || OTP.maxlength)">
                    <div *ngIf="OTP.errors.required" class="OTPerrorShow">
                        The OTP field cannot be blank.
                    </div>
                    <div *ngIf=" OTP.errors.pattern" class="OTPerrorShow">
                        Only digits are allowed.
                    </div>
                    <div *ngIf="!OTP.errors.pattern || OTP.errors.maxlength" class="OTPerrorShow">
                        OTP should be 4 digits .
                    </div>
                </div>
                <div *ngIf="otpError == otpError" class="OTPerrorShow">{{otpError}}</div>
            </div>
            <div class="OTPButtonDiv">
                <div class="p-g-12 " style="display: flex !important; justify-content: space-evenly !important; ">
                    <button style=" width: 110px !important; border-radius: 5px;" class="p-button
                    p-widget
                    p-state-default
                    p-corner-all" pButton (click)="resendOTP(OTP.value)">Re-send</button>
                    <input type="submit" id="proceed" (click)="verifyOTP(OTP.value)" [disabled]="!OTP.valid "
                        style=" width: 110px !important; border-radius: 5px;" class="p-button submitButton
                        p-widget
                        p-state-default
                        p-corner-all" value="Verify" />
                </div>
            </div>
        </div>
        <!-- ///////////////////////Upload Your Photo////////////////////////// -->
        <div class="responsive" *ngIf="activeIndex == 2">
            <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
                    styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE"
                    animationDuration=".5s"></p-progressSpinner></div>
            <div class="profileImgContainer">
                <div class="imageError">
                    <p-message class="errors" *ngIf="isError" severity="error"
                        text=" {{profileErrorMessage}}"></p-message>
                </div>
                <h3>Upload your photo</h3>
                <div class="imgstyle">
                    <img *ngIf="!imageChangedEvent" (click)="profilePopup.click()" class="imageContainer" [src]="profileUrl == null ? gender2 == 'M' ?
                        'assets/layout/images/avatarBoyImage.png' :
                        'assets/layout/images/avatarGirlImage.png' : {profileUrl}" />
                    <div class="imgCropper" *ngIf="imageChangedEvent">
                        <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                            [aspectRatio]="1/1" [resizeToWidth]="200" [onlyScaleDown]="false" format="png"
                            (imageCropped)="imageCropped($event)"></image-cropper>
                    </div>

                </div>
                <div class="imageUploadButtonDiv">
                    <button class="p-button submitButton p-widget p-state-default p-corner-all"
                        (click)="finish()">Next</button>
                    <input accept="image/png, image/jpeg" type="file" class="changeEvent"
                        (change)="fileChangeEvent($event)" #profilePopup />
                    <button class=" p-button submitButton p-widget p-state-default p-corner-all" (click)="profilePopup.click()">
                        <span class="ui-button-text ui-c">
                            <i class="fa fa-camera" aria-hidden="true"></i> &nbsp;Select photo
                        </span>
                    </button>

                </div>
                <div style="display: flex; flex-direction: column;">

                    <!-- <span style="color: red; line-break: anywhere; width: 10em; line-height: 1.4em">Image size
                        maximum 5 MB</span> -->
                    <div class="p-g-0">
                        <ng-template>
                            <div class="ui-g-12">
                                <div class="spinit">
                                    <i class="fa fa-spinner" aria-hidden="true"></i>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
        <!-- ////////////////  vaccinated  or not ////////////////////// -->
        <!-- <div class="responsive" *ngIf="activeIndex == 3">
            <div class="vaccinated , profileImgContainer">
                <h4>
                    Have you been vaccinated against Covid-19?
                </h4>
                <div class="ui-g-3 imgstyle">
                    <img class="imageContainer" src='assets/layout/images/vaccine.png' />

                </div>
                <div class="vaccinatedButtonDiv">
                    <button style="width: 120px !important;
                                        border-radius: 5px !important;" class="p-button submitButton
                                        p-widget
                                        p-state-default
                                        p-corner-all" (click)="covidYes()">Yes</button>
                    <button style="width: 120px !important;
                                        border-radius: 5px !important;" class=" p-button submitButton
                                        p-widget
                                        p-state-default
                                        p-corner-all " (click)="covidNo()">No</button>
                </div>
            </div>
        </div> -->
        <!-- ///////////////////////Upload Covid Card Image////////////////////////// -->
        <!-- <div class="cardResponsive" *ngIf="activeIndex == 4">
            <div class="profileImgContainer">
                <div class="imageError">
                    <p-message class="errors" *ngIf="isError" severity="error"
                        text=" {{profileErrorMessage}}"></p-message>
                </div>
                <h4>Upload covid card
                    image</h4>
                <div class="covidimgstyle">

                    <img *ngIf="!covidCardChangedEvent" (click)="covidImagePopup.click()" class="imageContainer"
                        [src]="covidImageUrl == null ? 'assets/layout/images/covid.png': covidImageUrl" />

                    <div class="imgCropper" *ngIf="covidCardChangedEvent">
                        <image-cropper [imageChangedEvent]="covidCardChangedEvent" [maintainAspectRatio]="true"
                            [aspectRatio]="4/3" [resizeToWidth]="321" [onlyScaleDown]="false" format="png"
                            (imageCropped)="covidCropped($event)"></image-cropper>
                    </div>
                </div>
                <div class="imageUploadButtonDiv">
                    <button class="p-button submitButton p-widget p-state-default p-corner-all"
                    (click)="covidFinish()">Next</button>
                    <input class="changeEvent" accept="image/png, image/jpeg" type="file"
                        (change)="covidChangeEvent($event)" #covidImagePopup />
                    <button (click)="covidImagePopup.click()"
                    class="p-button submitButton p-widget p-state-default p-corner-all">
                        <span class="ui-button-text ui-c">
                            <i class="fa fa-camera" aria-hidden="true"></i> &nbsp;Select photo
                        </span>
                    </button>
                </div>
            </div>
        </div> -->
        <!-- /////////////////////////Upload CNIC//////////////////////////////// -->
        <div class="nicresponsive" *ngIf="activeIndex == 5">

            <div class="profileImgContainer">
                <div class="imageError">
                    <p-message class="errors" *ngIf="isError" severity="error"
                        text=" {{profileErrorMessage}}"></p-message>
                </div>
                <h4>Upload CNIC
                </h4>
                <div class="nicimgstyle">
                    <img *ngIf="!CNICChangedEvent" (click)="CNICImagePopup.click()" class="imageContainer"
                        [src]="CNICImageUrl == null ? 'assets/layout/images/CNIC.png': CNICImageUrl" />
                    <div class="imgCropper" *ngIf="CNICChangedEvent">
                        <image-cropper [imageChangedEvent]="CNICChangedEvent" [maintainAspectRatio]="true"
                            [aspectRatio]="4/3" [resizeToWidth]="321" [onlyScaleDown]="false" format="png"
                            (imageCropped)="CNICCropped($event)"></image-cropper>
                    </div>
                </div>
                <div class="imageUploadButtonDiv">
                    <button class="p-button submitButton p-widget p-state-default p-corner-all"
                    (click)="CNICFinish()">Next</button>
                    <input class="changeEvent" accept="image/png, image/jpeg" type="file"
                        (change)="CNICChangeEvent($event)" #CNICImagePopup />
                    <button class="p-button submitButton p-widget p-state-default p-corner-all"
                    (click)="CNICImagePopup.click()">
                        <span>
                            <i class="fa fa-camera" aria-hidden="true"></i> &nbsp;Select photo
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="activeIndex == 6" class="thankYou">
            <h2 class="top-heading">
                Welcome to the GYM
            </h2>
            <div class="center-note thankYou">
                <p>Your request has been sent for approval. <br/> Your request number is:<span class="first-word-bold">{{requestId}}.</span></p>
                <p><span class="first-word-bold">Note:</span> Please show your request number at the counter.

                OR tap <span style="display: inline-flex; align-items: center; margin-right: 5px;">here.</span>
                <span style="display: inline-flex; align-items: center;"><button pButton pTooltip="Send Request Number" tooltipPosition="top" type="button"
                    style="background-color: #25D366; border: none; border-radius: 50%; padding: 8px; display: flex; align-items: center; width:35px; height: 35px; justify-content: center;">
                    <i class="fa fa-whatsapp" (click)="openWhatsApp()" style="color: white; width: 15px; height: 15px;"></i>
                  </button>
                </span>
                </p>
            </div>
            <h3 class="bottom-heading">
                Thank you for registration.
            </h3>
        </div>
    </div>
    <app-public-footer [branch]="branch"></app-public-footer>
</div>